import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import EditOutlined from "@mui/icons-material/EditOutlined";

import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import TeamBasicDetail from "./teamComponents/TeamBasicDetail";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useGetTeamDetailQuery } from "store/services/teamApi";

const TeamDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Teams", path: "/app/crm/team/list" },
    { title: "Team Detail" },
  ];

  // RTK Query
  const {
    data: teamDetail,
    isLoading: loadingTeamDetail,
    error,
  } = useGetTeamDetailQuery(id);

  const PageActions = () => (
    <Link to={`/app/crm/team/${id}/edit`}>
      <Button variant="contained" startIcon={<EditOutlined />}>
        Edit
      </Button>
    </Link>
  );

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingTeamDetail}
      headerActions={<PageActions />}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        {!loadingTeamDetail ? (
          <TeamBasicDetail teamDetail={teamDetail} />
        ) : (
          <InfoGridSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default TeamDetailScreen;
